import React, { useEffect, useState } from "react";
import { Archive, Heart, BookOpen } from "lucide-react";
import { API, axios } from "../lib/planner";
import { AppNav } from "../components/planner/AppNav";

const TEXTURE = "https://static.prod-images.emergentagent.com/jobs/ba076ba6-cbb6-4319-9066-aa1342f64d2e/images/081040ebe7a7c84b8ab2b0fe8035be59edefdf550c49e2fe2ad159853745d85d.jpeg";

export default function ArchivePage() {
  const [prayers, setPrayers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/prayers/answered`).then((r) => {
      setPrayers(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="min-h-screen bg-clay-app">
      <header className="sticky top-0 z-30 overflow-hidden border-b border-[#E5E1D8] bg-clay-app/90 backdrop-blur-xl">
        <div
          className="pointer-events-none absolute inset-0"
          style={{ background: "radial-gradient(600px circle at 92% -40%, rgba(196,164,124,0.18), transparent 60%)" }}
        />
        <div className="relative mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-4 px-6 py-5 lg:px-10">
          <div>
            <p className="font-sans text-xs uppercase tracking-[0.25em] text-ink-muted">Answered Prayers</p>
            <h1 className="font-serif text-3xl font-medium tracking-tight text-ink sm:text-4xl">The Archive</h1>
          </div>
          <AppNav />
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-6 py-8 lg:px-10">
        <div
          className="relative mb-8 flex items-center gap-4 overflow-hidden rounded-2xl border border-[#E5E1D8] p-8 shadow-[0_8px_30px_-10px_rgba(44,53,41,0.12)]"
          style={{ backgroundColor: "#E7EEE3" }}
        >
          <div
            className="pointer-events-none absolute inset-0 opacity-40"
            style={{ backgroundImage: `url(${TEXTURE})`, backgroundSize: "cover", backgroundPosition: "center right", maskImage: "linear-gradient(to left, rgba(0,0,0,1), transparent 70%)", WebkitMaskImage: "linear-gradient(to left, rgba(0,0,0,1), transparent 70%)" }}
          />
          <div className="relative">
            <p className="font-serif text-2xl leading-snug text-ink sm:text-3xl">
              A record of faithfulness — {prayers.length} prayer{prayers.length === 1 ? "" : "s"} answered.
            </p>
            <p className="mt-1 font-sans text-sm text-ink-soft">Return here whenever you need to remember what God has done.</p>
          </div>
        </div>

        {loading ? (
          <p className="font-serif text-xl italic text-ink-soft">Gathering your testimonies…</p>
        ) : prayers.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-[#E5E1D8] p-12 text-center" data-testid="archive-empty">
            <Archive className="mx-auto mb-4 h-8 w-8 text-ink-muted" />
            <p className="font-serif text-2xl text-ink">No answered prayers yet</p>
            <p className="mt-2 font-sans text-sm text-ink-muted">Mark a prayer as answered and it will be archived here as a lasting testimony.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2" data-testid="archive-list">
            {prayers.map((p, i) => {
              const scriptureRef = [p.scripture, p.chapter, p.verse].filter(Boolean).join(" ");
              return (
                <div
                  key={p.id}
                  className="animate-rise rounded-2xl border border-[#E5E1D8] bg-white p-6 shadow-[0_4px_24px_-6px_rgba(44,53,41,0.06)]"
                  style={{ animationDelay: `${i * 50}ms` }}
                  data-testid={`archive-${p.id}`}
                >
                  <div className="mb-3 flex items-center justify-between">
                    <span className="flex items-center gap-1.5 rounded-full bg-clay-soft px-3 py-1 text-xs font-medium text-[#9c7f52]">
                      <Heart className="h-3 w-3 fill-[#C4A47C] text-[#C4A47C]" /> Answered
                    </span>
                    <span className="font-sans text-xs text-ink-muted">{p.day} · {p.week_key}</span>
                  </div>
                  <p className="font-serif text-2xl leading-tight text-ink">{p.prayer_point || "Untitled prayer"}</p>
                  {scriptureRef && (
                    <p className="mt-2 flex items-center gap-1.5 font-sans text-xs uppercase tracking-[0.1em] text-ink-muted">
                      <BookOpen className="h-3.5 w-3.5" /> {scriptureRef}
                    </p>
                  )}
                  {p.answered_note && (
                    <p className="mt-3 border-l-2 border-brand/40 pl-3 font-serif text-lg italic leading-snug text-ink-soft">
                      “{p.answered_note}”
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </main>
    </div>
  );
}
